import { render, staticRenderFns } from "./Labs.vue?vue&type=template&id=452c1e94&scoped=true&"
import script from "./Labs.vue?vue&type=script&lang=js&"
export * from "./Labs.vue?vue&type=script&lang=js&"
import style0 from "./Labs.vue?vue&type=style&index=0&id=452c1e94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452c1e94",
  null
  
)

export default component.exports